import { render, staticRenderFns } from "./Assistant.vue?vue&type=template&id=7117381f"
import script from "./Assistant.vue?vue&type=script&lang=js"
export * from "./Assistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports